import React from 'react';
import { ListGroup } from 'react-bootstrap';
import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';
import { useSelector } from 'react-redux';

const NavGroup = ({ layout, group }) => {
  const { role } = useSelector((state) => state.auth);
  const { currentVendor } = useSelector((state) => state.vendor);
  let navItems = '';
  if (group.children) {
    const groups = group.children;
    navItems = Object.keys(groups).map((item) => {
      item = groups[item];
      if (item.allowedRoles === '*') {
        switch (item.type) {
          case 'collapse':
            return <NavCollapse key={item.id} collapse={item} type="main" />;
          case 'item':
            if (currentVendor.VendorType === item.allowedVendors || item.allowedVendors === '*') {
              return <NavItem layout={layout} key={item.id} item={item} />;
            } else {
              return false;
            }
          default:
            return false;
        }
      } else {
        if (role === item.allowedRoles || item.allowedRoles.includes(role)) {
          switch (item.type) {
            case 'collapse':
              return <NavCollapse key={item.id} collapse={item} type="main" />;
            case 'item':
              if (currentVendor.VendorType === item.allowedVendors || item.allowedVendors === '*') {
                return <NavItem layout={layout} key={item.id} item={item} />;
              } else {
                return false;
              }
            default:
              return false;
          }
        } else {
          return false;
        }
      }
    });
  }

  return (
    <React.Fragment>
      <ListGroup.Item as="li" bsPrefix=" " key={group.id} className="nav-item pcoded-menu-caption">
        <label className="text-capitalize">{group.title}</label>
      </ListGroup.Item>
      {navItems}
    </React.Fragment>
  );
};

export default NavGroup;
